import { components } from "react-select";
import {
  WorkOrderStatus,
  workOrderStatusMap,
} from "features/WorkOrders/constants/work-order.constants";

export interface WorkOrderSelectOption {
  value: number;
  label: string;
  title?: string | null;
  status?: string | null;
}

function WorkOrderStatusBadge({
  status,
}: {
  status: string | undefined | null;
}) {
  if (!status) return null;
  const entry = workOrderStatusMap[status as WorkOrderStatus];
  if (!entry) return null;
  return (
    <span className={`badge bg-${entry.color}-subtle text-${entry.color} ms-1`}>
      {entry.label}
    </span>
  );
}

export function WorkOrderOption(props: any) {
  const data = props.data as WorkOrderSelectOption;
  return (
    <components.Option {...props}>
      <div className="d-flex flex-column py-1">
        <div className="d-flex align-items-center justify-content-between gap-2">
          <span className="fw-medium text-body">{data.label}</span>
          <WorkOrderStatusBadge status={data.status} />
        </div>
        {data.title?.trim() ? (
          <small className="text-muted text-truncate">
            {data.title.trim()}
          </small>
        ) : null}
      </div>
    </components.Option>
  );
}

export function WorkOrderSingleValue(props: any) {
  const data = props.data as WorkOrderSelectOption;
  return (
    <components.SingleValue {...props}>
      <span className="d-inline-flex align-items-center gap-1 min-w-0 text-truncate">
        <span className="fw-medium text-truncate">{data.label}</span>
        {data.title?.trim() ? (
          <span className="text-muted text-truncate small">
            · {data.title.trim()}
          </span>
        ) : null}
      </span>
    </components.SingleValue>
  );
}
